import styled, { css } from 'styled-components';
import {
  Map,
  TimeFive,
  CheckSquare,
  BarChartAlt2,
} from '@styled-icons/boxicons-solid';
import { MenuAltRight } from '@styled-icons/boxicons-regular';
import { Gumroad } from '@styled-icons/simple-icons/';
import logo from 'assets/images/logo-bayer-branco.png';
import { colors, fonts } from 'styles';

interface IButtonModule {
  active: boolean;
}

type ContainerProps = {
  testEnv?: boolean;
}

export const Container = styled.aside<ContainerProps>`
  width: 100%;
  max-width: 252px;
  height: 100%;
  min-height: 100vh;
  background-color: ${colors.bayer};
  padding: 40px 24px;
  position: relative;
  z-index: 1;
  box-shadow: 5px 0 30px rgba(0, 0, 0, 0.1);

   ${({ testEnv }) => testEnv && `
    padding-top: 64px;
  `}
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  overflow-y: auto;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Logo = styled.img.attrs({ src: logo })`
  width: 100%;
  max-width: 72px;
  align-self: center;
`;

export const ButtonModule = styled.button.attrs({
  type: 'button',
})<IButtonModule>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  background-color: transparent;

  ${({ active }) =>
    !active &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `}
`;

export const IconTracking = styled(Map).attrs({ size: 16 })`
  margin-right: 8px;
  color: #fff;
`;

export const IconSchedule = styled(TimeFive).attrs({ size: 16 })`
  margin-right: 8px;
  color: #fff;
`;

export const IconRouter = styled(Gumroad).attrs({ size: 16 })`
  margin-right: 8px;
  color: #fff;
`;

export const IconCheckFreight = styled(CheckSquare).attrs({ size: 16 })`
  margin-right: 8px;
  color: #fff;
`;

export const IconSettings = styled(MenuAltRight).attrs({ size: 16 })`
  margin-right: 8px;
  color: #fff;
`;

export const IconControlTower = styled(BarChartAlt2).attrs({ size: 16 })`
  margin-right: 8px;
  color: #fff;
`;

export const ModuleTitle = styled.h3<{ isHomolog: boolean }>`
  display: flex;
  align-items: center;
  font-size: 16px;
  text-align: left;
  margin-bottom: 4px;
  color: ${colors.white};
`;

export const ModuleDescription = styled.p`
  font-family: ${fonts.OpenSans};
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  color: ${colors.gray};
  opacity: 0.8;
`;

type SubMenuModuleProps = {
  active: boolean;
};

export const SubMenuModule = styled.div<SubMenuModuleProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
  transition: 300ms ease;
  width: 100%;
  margin-top: 16px;

  ${({ active }) =>
    !active &&
    css`
      opacity: 0;
      display: none;
    `};
`;

export const SubMenuModuleItem = styled.button`
  display: flex;
  align-items: center;
  padding: 8px 4px;
  background-color: transparent;
  transition: 300ms ease;
  font-family: ${fonts.GilroySemiBold};
  letter-spacing: 0.01em;
  color: #fff;

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.darkRgba25};
  }

  &:hover {
    color: ${colors.greenBayer};
  }
`;
